// Hack to make jQuery available to extensions that do not declare their own dependencies
// https://stackoverflow.com/questions/34338411/how-to-import-jquery-using-es6-syntax
import $ from "jquery";

window.jQuery = window.$ = $;
export default $;
export { $ };
